export default __webpack_public_path__ + "static/leftHand-d24f0b793ab86900c00587548a1f8b78.png";